import "../../../../content/departments/change/change.css";
import * as React from 'react';
export default {
  React
};